import { reactive, computed } from 'vue';

const state = reactive({
    toasts: []
});

// Track active messages to prevent duplicates
const activeMessages = new Set();

export const useToast = () => {
    const add = (message, type = 'success', duration = 4000) => {
        // Prevent duplicate messages from showing at the same time
        if (activeMessages.has(message)) return;

        const id = Date.now() + Math.random();
        activeMessages.add(message);

        state.toasts.push({
            id,
            message,
            type,
            duration,
            progress: 100
        });

        // Progress bar countdown
        const interval = setInterval(() => {
            const toast = state.toasts.find(t => t.id === id);
            if (toast) {
                toast.progress -= (100 / (duration / 100));
            } else {
                clearInterval(interval);
            }
        }, 100);

        setTimeout(() => {
            remove(id);
            activeMessages.delete(message);
            clearInterval(interval);
        }, duration);
    };

    const remove = (id) => {
        const toast = state.toasts.find(t => t.id === id);
        if (toast) activeMessages.delete(toast.message);
        const index = state.toasts.findIndex((t) => t.id === id);
        if (index !== -1) {
            state.toasts.splice(index, 1);
        }
    };

    return {
        toasts: computed(() => state.toasts),
        add,
        remove
    };
};
